import React from 'react';
import { Card } from '@blueprintjs/core';
import { Table, ITableConfig } from '../../components/common/table';

import CardContainer from '../common/CardContainer';
import PagedResultSet from '../../models/common/PagedResultSet';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

export interface IProjectsPageDispatchProps {
    navigate: (path: string) => void;
}

class ProjectsPage extends React.Component<IProjectsPageDispatchProps> {
    constructor(props: IProjectsPageDispatchProps) {
        super(props);

        this.rowClick = this.rowClick.bind(this);
    }

    private rowClick(id: number | string) {
        this.props.navigate('/clients/1/projects/1/tracts');
    }

    public render() {
        const projects = [
            {
                id: 1,
                client: 'Southwest',
                project: 'Southwest Project 1',
                projectType: 'Lease Acquisition',
            },
        ];

        const prs = new PagedResultSet<object>();
        prs.items = projects;
        prs.pageNumber = 1;
        prs.pageSize = 5;
        prs.totalRecords = 1;

        const tableConfig: ITableConfig = {
            rowCount: 5,
            idField: 'id',
            pageNumber: 1,
            columns: [
                { name: 'Client', mapping: 'client' },
                { name: 'Project', mapping: 'project' },
                { name: 'Project Type', mapping: 'projectType' },
            ],
        };

        return (
            <CardContainer>
                <Card elevation={1}>
                    <div className="card-header lh-mb-small">Projects</div>
                    <Table isLoading={false} tableConfig={tableConfig} data={prs} onRowClick={this.rowClick} enablePaging={true} />
                </Card>
            </CardContainer>
        );
    }
}

const mapDispatchToProps: IProjectsPageDispatchProps = {
    navigate: (path: string) => push(path),
};

export default connect(undefined, mapDispatchToProps)(ProjectsPage);



// WEBPACK FOOTER //
// ./src/components/project/ProjectsPage.tsx